var $gallery = $(".js-gallery");
if ($gallery.length) {
    $gallery.lightGallery({
        selector: '.js-gallery-item',
    });
}
